function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * The Toaster manages the interactions between
 * the ToasterManger and the toast API.
 */


var Toaster = function Toaster() {
  var _this = this;

  _defineProperty(this, "toastManager", null);

  _defineProperty(this, "closeAll", function () {
    if (_this.toastManager == null) return [];
    return _this.toastManager.closeAll();
  });

  _defineProperty(this, "notify", function (title, settings) {
    if (settings === void 0) {
      settings = {};
    }

    if (_this.toastManager == null) return null;
    return _this.toastManager.notify(title, _extends({}, settings, {
      intent: undefined
    }));
  });

  _defineProperty(this, "success", function (title, settings) {
    if (settings === void 0) {
      settings = {};
    }

    if (_this.toastManager == null) return null;
    return _this.toastManager.notify(title, _extends({}, settings, {
      intent: "success"
    }));
  });

  _defineProperty(this, "warning", function (title, settings) {
    if (settings === void 0) {
      settings = {};
    }

    if (_this.toastManager == null) return null;
    return _this.toastManager.notify(title, _extends({}, settings, {
      intent: "warning"
    }));
  });

  _defineProperty(this, "error", function (title, settings) {
    if (settings === void 0) {
      settings = {};
    }

    if (_this.toastManager == null) return null;
    return _this.toastManager.notify(title, _extends({}, settings, {
      intent: "error"
    }));
  });
};

var toaster = new Toaster();
export default toaster;